export function getValueOrDefault<TType> (
    value: TType | undefined,
    defaultValue: TType | undefined,
): TType | undefined {
    if (value !== undefined) {
        return value;
    }

    if (defaultValue !== undefined) {
        return defaultValue;
    }

    return undefined;
}

export function getVisibilityClass (
    sizePrefix: string,
    visibilityType: string,
    visibility: boolean | undefined,
    styles: { [key: string]: string },
): string {
    if (!visibility) {
        return '';
    }

    return styles[`${sizePrefix}-${visibilityType}`];
}
